import { useEffect, useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { useAuth } from '../contexts/AuthContext'

const LOCALE_MAP = {
  pl: 'pl-PL',
  en: 'en-US',
  de: 'de-DE',
}

const useLanguage = () => {
  const { user } = useAuth()
  const { i18n } = useTranslation()
  const language = user?.preferences?.language || 'pl'

  const applyLanguage = useCallback((lang) => {
    if (i18n.language !== lang) {
      i18n.changeLanguage(lang)
    }
    document.documentElement.lang = lang
    localStorage.setItem('i18nextLng', lang)
  }, [i18n])

  useEffect(() => {
    applyLanguage(language)
  }, [language, applyLanguage])

  return {
    language,
    locale: LOCALE_MAP[language] || 'pl-PL',
  }
}

export default useLanguage
